export const REMOVE_ISSUE = 'REMOVE_ISSUE';
// export const DELETE_ISSUE = 'DELETE_ISSUE';
export const BULK_ACTION = 'BULK_ACTION';
